<p-toast position="bottom-right"></p-toast>
<p-confirmDialog appendTo="body" ></p-confirmDialog>
<app-cc-form-dialog #ccFlexAddFormDialog [transPartKey]="transPartKey"
                    [loading]="formLoading" [submitted]="false"
                    [(dialogFormVisible)]="dialogFormVisible"
                    [formConfig]="formConfig" [dialogFormTitle]="dialogFormTitle"
                    [(formRecord)]="formRecord" (onSubmitEvent)="save()"
                    [loadingProgressValue]="loadingProgressValue"
                    [submitButtonLabel]="'common.dialog.save'|translate"
                    dialogClass="cc-dialog-sm"
                    (close)="closeDialog()"
></app-cc-form-dialog>

